<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-row class="mb-2">

        <b-col v-if="infoPanelOpen" md="4">
          <b-card>
            <b-row>
              <b-col class="d-flex align-items-center">
                <b-avatar :src="staff.image"
                          size="25px"
                          v-if="staff.image">
                </b-avatar>
                <b-avatar v-else
                          size="25px"
                          :text="avatarFromName(staff.name).text"
                          :style="avatarFromName(staff.name).style">
                </b-avatar>
                &nbsp;<b>{{staff.name}}</b>
                <b-button variant="link" class="list-view-icon-btn ml-auto" v-b-tooltip.hover title="Ocultar información" aria-label="Ocultar información" @click="infoPanelOpen = false">
                  <AppIcon name="chevron_left" />
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col>

                <div class="ml-5 mt-2">
                  <div v-if="!staff.email">
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-badge variant="warning" class="badget-custom">No tiene un email asociado</b-badge>
                  </div>
                  <div v-else>
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-link :href="'mailto:' + staff.email">
                      {{ staff.email }}
                    </b-link>
                  </div>
                </div>

                <div class="ml-5" v-if="staff.phone">
                  <AppIcon name="call" /> &nbsp;&nbsp;
                  <b-link :href="'tel:' + staff.phone">
                    {{ staff.phone }}
                  </b-link>
                </div>

              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <div v-else
             class="entity-info-panel-collapsed"
             role="button"
             tabindex="0"
             @click="infoPanelOpen = true"
             @keyup.enter="infoPanelOpen = true"
             v-b-tooltip.hover.right
             title="Mostrar información del staff">
          <AppIcon name="chevron_right" />
          <span>Staff</span>
        </div>

        <b-col :md="infoPanelOpen ? 8 : null">

          <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark"
                  v-if="showTab">

            <b-tab v-if="this.configTabs.configurationsDefault.show" :active="tabs.configurationsDefault" @click="setActiveTab('configurationsDefault')">
                <template #title><AppIcon name="settings" class="mr-1" /> Configuraciones</template>
                <tab-configurations-default :staff="staff" :staffID="staffID"></tab-configurations-default>
            </b-tab>

            <b-tab v-if="this.configTabs.observationsInternal.show" :active="tabs.observationsInternal" @click="setActiveTab('observationsInternal')">
                <template #title><AppIcon name="chat-square-text" class="mr-1" /> Notas</template>
                <tab-observations-internal :staff="staff" :staffID="staffID"></tab-observations-internal>
            </b-tab>

          </b-tabs>
          <EmptyState v-else
                      icon="person"
                      title="No se encontró información de módulos relacionados" />

        </b-col>
      </b-row>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>
        </div>
      </b-card>
        
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Theme from '@/config/theme'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Param from '@/config/parameters'
  import Helper from '@/handler/helper'
  import Storage from '@/handler/storageLocal'
  import Widget from '@/components/inc/widget/widget'
  import TabConfigurationsDefault from './tabs/configurationsDefault'
  import TabObservationsInternal from './tabs/observationsInternal'
  import {EventBus} from '@/handler/event-bus'
  import Funciones from '@/handler/funciones'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      Widget,
      TabConfigurationsDefault,
      TabObservationsInternal,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PERSONAL,
          profile_id: Profiles.PERSONAL,
          view_reference: 'view',
          elements: {}
        },
        configTabs: {
          configurationsDefault: {
            show: false,
          },                    
          observationsInternal: {
            show: false,
          },
        },        
        configWidget: {
          module_id: Modules.PERSONAL,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        primaryColor: '',
        infoPanelOpen: true,
        staffID: 0,
        staff: {},
        tabs: {
          configurationsDefault: true,
          observationsInternal: true,          
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.staffID = this.$route.params.staffID  

      this.setup()
      this.load()

      this.configAccess()
    
      this.restoreStatusTabsStorage()
    }, 
    computed: {
      showTab () {
        var status = false
        if(this.configTabs.configurationsDefault.show) {
          status = true
        }                
        if(this.configTabs.observationsInternal.show) {
          status = true
        }
        return status
      },   
      showConfigurationsDefault() {
        let status = false
        if(this.showDeposit || this.showFinance || this.showSales) {
          status = true
        }
        return status
      },

      // MODULES
      showDeposit() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.DEPOSITOS) {                             
            status = true                       
          }
        })        
        return status
      },          
      showFinance() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.FINANZAS) {                             
            status = true                       
          }
        })        
        return status
      },    
      showSales() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.VENTAS) {                             
            status = true                       
          }
        })        
        return status
      },              
    },    
    methods: {
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      setMetaTitle(title) {
        EventBus.$emit('Update:TabTitle', 'Staff: ' + title)        
      },      
      load() {
        let loader = this.$loading.show();
        var result = serviceAPI.mostrar(this.staffID)

        result.then((response) => {
          var data = response.data
          this.staff = data          

          this.setMetaTitle(this.staff.name)

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Theme.PRIMARY_COLOR
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      },

      configAccess() {  
        if(this.showConfigurationsDefault) {
          this.configTabs.configurationsDefault.show = true
        }        

        if(Param.P25) {
          this.configTabs.observationsInternal.show = true
        }                  
      },       

      //TABS
      disableAllTabs() {
        this.tabs.configurationsDefault = false
        this.tabs.observationsInternal = false        
      },
      setActiveTab(value) {
        this.disableAllTabs()

        switch (value) {
          case 'configurationsDefault':
            this.tabs.configurationsDefault = true
            break;
                      
          case 'observationsInternal':
            this.tabs.observationsInternal = true
            break;

          default:
            this.tabs.configurationsDefault = true
            break;
        }

        this.saveStatusTabsStorage()
      },

      // FILTROS SAVE
      saveStatusTabsStorage() {
        Storage.setValue('tabs_view_staff', JSON.stringify(this.tabs))
      },
      restoreStatusTabsStorage() {
        if(Storage.getValue('tabs_view_staff')) {
          this.tabs = JSON.parse(Storage.getValue('tabs_view_staff'))
        }         
      }, 

    }    
   
  }
</script>

<style scoped>
  .entity-info-panel-collapsed {
    display: flex;
    flex: 0 0 34px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 260px;
    margin-left: 15px;
    border: 1px solid var(--app-color-border);
    border-radius: 4px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-primary);
    cursor: pointer;
    writing-mode: vertical-rl;
  }
  @media (max-width: 767.98px) {
    .entity-info-panel-collapsed {
      width: calc(100% - 30px);
      min-height: 34px;
      margin-right: 15px;
      margin-bottom: 10px;
      flex-basis: auto;
      writing-mode: horizontal-tb;
    }
  }
</style>
